
define('ldsh!modules/page_generator/templates/generator_amp_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- pseudo HEAD -->\n   <!-- variant styles -->\n  <style>\n    #popup' +
((__t = ( stepId )) == null ? '' : __t) +
' .popup__overlay {\n      background-color: ' +
((__t = ( popupProperties.overlayRGBA )) == null ? '' : __t) +
';\n    }\n    #popup' +
((__t = ( stepId )) == null ? '' : __t) +
' .popup {\n      width: ' +
((__t = ( popupProperties.width )) == null ? '' : __t) +
';\n      height: ' +
((__t = ( popupProperties.height )) == null ? '' : __t) +
';\n      border-radius: ' +
((__t = ( popupProperties.windowRadius )) == null ? '' : __t) +
'px;\n      font-family: ' +
((__t = ( popupProperties.fontFamily )) == null ? '' : __t) +
';\n      background-color: ' +
((__t = ( popupProperties.backgroundColor )) == null ? '' : __t) +
';\n      color: ' +
((__t = ( popupProperties.fontColor )) == null ? '' : __t) +
';\n    }\n    #popup' +
((__t = ( stepId )) == null ? '' : __t) +
' .popup a:not(.popup__trigger--close) {\n      color: ' +
((__t = ( popupProperties.linkColor )) == null ? '' : __t) +
';\n    }\n\n    ' +
((__t = ( elementStyles )) == null ? '' : __t) +
'\n   </style>\n' +
((__t = ( extractedStyles )) == null ? '' : __t) +
'\n' +
((__t = ( extractedScripts )) == null ? '' : __t) +
'\n' +
((__t = ( styles )) == null ? '' : __t) +
'\n<!-- /pseudo HEAD -->\n\n<!-- pseudo BODY -->\n<amp-lightbox id="popup' +
((__t = ( stepId )) == null ? '' : __t) +
'" scrollable="true" layout="nodisplay">\n  <div class="popup__overlay">\n    ';
 if (popupProperties.closeOnClickOutside) { ;
__p += '\n    <a class="popup--cancel popup__trigger--close" on="tap:popup' +
((__t = ( stepId )) == null ? '' : __t) +
'.close" role="button"></a>\n    ';
 } ;
__p += '\n    <div class="popup ' +
((__t = (popupProperties.windowPosition )) == null ? '' : __t) +
'">\n      <div class="popup__title">\n        <h2>' +
((__t = (popupProperties.title )) == null ? '' : __t) +
'</h2>\n      </div>\n      <a class="popup--close popup__trigger--close" on="tap:popup' +
((__t = ( stepId )) == null ? '' : __t) +
'.close" role="button">&times;</a>\n      <div class="popup__content">\n        ' +
((__t = ( content )) == null ? '' : __t) +
'\n      </div>\n    </div>\n  </div>\n</amp-lightbox>\n<!-- / pseudo BODY -->\n';

}
return __p
};});

